module.exports = __webpack_public_path__ + "static/media/python.1649c080.png";